
<template lang="pug">
div
  .grid__row-border(
    v-for="border of borders"
    :style="border.style"
  )
</template>

<script>
export default {
  props: {
    grid: {type: Object, required: true},
    rows: {type: Array, required: true},
  },

  computed: {
    borders() {
      const borders = []
      for(const [index, row] of this.rows.entries()) {
        // .border = true のカラムの上側にバーをつける
        if(row.border) {
          borders.push({
            style: {
              top: this.grid.cellH * index - 2 + 'px',
            },
          })
        }
      }
      return borders
    },
  },
}
</script>

<style lang="sass">
.grid__row-border
  background-color: black
  height: 2px
  left: 0
  pointer-events: none
  position: absolute
  right: 0
  z-index: 3
</style>
